import React, { useEffect, useState, useContext} from "react";
import logo from "shared/assets/logo.svg";
//import { ActionButton } from "@ds/ds-snam/react";
import { DsLayout, LANGUAGES, /*ILanguage,*/ LanguageKey, SNAM_PLANTS, SnamPlantKey } from "shared/constants";
import { useTranslation } from "react-i18next";
import { setAxiosHeader } from "shared/utils/axiosUtils";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { Avatar, ProfileMenu } from "@ds/ds-snam/react";

const MainFooter: React.FC = (): JSX.Element => {
  const { i18n } = useTranslation();
  const {t} = useTranslation(['app']);
  const [showLangMenu, setShowLangMenu] = useState<boolean>(false);
  const appUser:AppUser|undefined = useAppUser();
  const layoutMode = useSelector((state:RootState)=>{
    return state.dsLayout.mode;
})


const getTestLinkComponent = () => {
    return <ds-textlink
    textlink-text-size="BIG"
    textlink-neutral={true}
    textlink-url="javascript:void(0)"
    textlink-text="Textlink"
    textlink-weight="w700"
    icon="icon-arrow-up-right"
    icon-position="right"
    textlink-aria-label="vai a textlink - link esterno"
    is-external-link={false}
    textlink-stop-animation={true}
    ></ds-textlink>
}

const getDsIconComponent = (link:string,label:string,icon:string) => {
    return <a href={link} target="_blank" aria-label={label}>
        <ds-icon
        icon={icon}
        role="link"
        icon-size="large"
        icon-filled={true}
        ></ds-icon>
    </a>
}
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1023); // Cambia la larghezza se necessario
    };
    checkScreenSize(); // Controllo iniziale
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <footer className="ds-footer" style={{ 
        position: "fixed",
        bottom:'0',
        zIndex:3, //prima era 99
        display: isMobile ? "none" : "block", // Nasconde il footer su mobile
    }}>
        <h2 className="visually-hidden">intestazione footer</h2>
        <div className="ds-footer__logos" style={{width:'100px'}}>
            <div className="ds-footer__logo">
            <img src={logo} alt="logo" style={{ width: "40px", height: "40px" }} />
            </div>
            {/*<div className="ds-footer__product-logo">
            <img src="https://via.placeholder.com/100x50?text=Product+Logo" alt="product logo" />
            </div>*/}
        </div>
        {/*<div className="ds-footer__upper-section">
            <h3 className="visually-hidden">link utili</h3>
            {getTestLinkComponent()}
            {getTestLinkComponent()}
            {getTestLinkComponent()}
            {getTestLinkComponent()}
        </div>
        <div
            className="ds-footer__lower-section ds-dividers ds-dividers--thin ds-dividers--full_solid ds-dividers--horizontal ds-dividers--top ds-dividers--gradient"
        >
            <div className="ds-footer__icons">
            <h3 className="visually-hidden">canali social</h3>
            {getDsIconComponent("https://facebook.com","vai a Facebook - link esterno - apre una nuova scheda","icon-facebook")}
            {getDsIconComponent("https://linkedin.com","vai a LinkedIn - link esterno - apre una nuova scheda","icon-linkedin")}
            {getDsIconComponent("https://instagram.com","vai a Instagram - link esterno - apre una nuova scheda","icon-instagram")}
            {getDsIconComponent("https://twitter.com","vai a Twitter - link esterno - apre una nuova scheda","icon-twitter")}
            </div>
        </div>*/}
        </footer>
  )
}

export default MainFooter;